var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
export class Countries {
  /**
   * Creates an instance of Countries.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof Countries
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetAvailableCountriesRq_ _getAvailableCountriesRq
   * @returns Promise<GetAvailableCountriesRq_>
   * @memberof Countries
   */
  getAvailableCountries(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/cesop/Countries", "GET", "application/json; charset=UTF-8", "application/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, isArray: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
